module.exports = __webpack_public_path__ + "static/media/plans.2f4a35a6.jpg";